import React from 'react';
import {connectRefinementList} from 'react-instantsearch-dom';
import cx from 'classnames';

import {useOverlayThatClosesOnOutsideClick} from '../../hooks/useOverlayThatClosesOnOutsideClick';

import './RefinementList.scss';

export const RefinementList = connectRefinementList(
  ({
    items,
    currentRefinement,
    refine,
    searchForItems,
    name,
    side = 'right',
    searchable = false,
    overrideLabels,
  }) => {
    const { isOpen, toggle, containerRef } = useOverlayThatClosesOnOutsideClick(
      { containerRef, isOpen, close: toggle }
    );

    const isInUse = currentRefinement.length > 0;

    if (overrideLabels) {
      items = items.map((item) => ({
        ...item,
        label: overrideLabels[item.label] ?? item.label,
      }));
    }

    return (
      <div
        className="dropdown-selector flex w-full lg:flex-1 lg:mt-0"
        ref={containerRef}
      >
        <div
          className={cx(
            'flex-1 filter-btn rounded-sm',
            isOpen || isInUse ? 'filter-btn--gold' : ''
          )}
          onClick={toggle}
        >
          <span>{name}</span>
          <i className={cx('fas', isOpen ? 'fa-caret-up' : 'fa-caret-down')} />
        </div>
        {isOpen && (
          <div className={cx('overlay', `overlay--${side}`)}>
            <div className="overlay-top">
              {searchable && (
                <div className="search-bar">
                  <i className="fas fa-search" />
                  <input
                    placeholder={`Search ${name}`}
                    onChange={(event) => searchForItems(event.target.value)}
                  />
                </div>
              )}
              <div
                className="flex-1 self-stretch simple-btn btn-ghost border border-30 text-sm font-normal ml-2 py-0"
                onClick={() => refine([])}
              >
                Clear
              </div>
            </div>
            <div className="item-list">
              {items.map((item) => (
                <div
                  onClick={() => {
                    refine(item.value);
                  }}
                  className={cx('item', item.isRefined && 'item--selected')}
                  key={item.label}
                >
                  {item.label} ({item.count})
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
);
